import Vue from 'vue'
import VueRouter from 'vue-router'
import WeaponList from '../views/WeaponList.vue'
import WeaponContent from '../views/WeaponContent.vue'
import WeaponModList from '../views/WeaponModList.vue'
import WeaponModContent from '../views/WeaponModContent.vue'
import HeroList from '../views/HeroList.vue'
import HeroContent from '../views/HeroContent.vue'
import ChipList from '../views/ChipList.vue'
import WallList from '../views/WallList.vue'
import WallContent from '../views/WallContent.vue'

Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        redirect: '/weapon'
    },
    {
        path: '/weapon',
        name: 'weaponList',
        component: WeaponList
    },
    {
        path: '/weapon/content/:id',
        name: 'weaponContent',
        component: WeaponContent
    },
    {
        path: '/weaponMod',
        name: 'weaponModList',
        component: WeaponModList
    },
    {
        path: '/weaponMod/content/:id',
        name: 'weaponModContent',
        component: WeaponModContent
    },
    {
        path: '/hero',
        name: 'heroList',
        component: HeroList
    },
    {
        path: '/hero/content/:id',
        name: 'heroContent',
        component: HeroContent
    },
    {
        path: '/chip',
        name: 'chipList',
        component: ChipList
    },
    {
        path: '/wall',
        name: 'wallList',
        component: WallList
    },
    {
        path: '/wall/content/:id',
        name: 'wallContent',
        component: WallContent
    },
    {
        path: '/*',
        redirect: '/weapon'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router